module.exports = __webpack_public_path__ + "static/team9-849abd91ec49018445b4b578cf91269a.jpg";